module.exports = __webpack_public_path__ + "assets1783936157458/img/kaifa-select.30491d71.svg";